import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import DragAndDrop from '../Common/dragAndDrop'
import './styles.css'


class ContenidoNuevo extends React.Component {

    render() {

        return (
            <div>

                {/* menú superior */}
                <TitleBar 
                    title={'Contenido nuevo'} 
                    handleOnCancel={this.props.handleOnCancel}
                    cancelarButtonLink='/Contenido'
                    handleOnSave={this.props.handleOnSave}
                    searchPlaceholder= "Contenido"
                />

                <Row>
                    <Col md={6}>
                        <Paper className='myBox no-margin'>
                            <TextField className='myInput'    
                                label='Tipo Contenido'
                                select
                                error={this.props.error && this.props.error.tipoContenido }
                                helperText={(this.props.error && this.props.error.tipoContenido)? this.props.error.tipoContenido :""}
                                name='idTipoContenidoSelected'
                                fullWidth
                                required
                                value={this.props.idTipoContenidoSelected}
                                onChange={this.props.handleOnChange}
                                InputLabelProps={{shrink: this.props.idTipoContenidoSelected !=="" && this.props.idTipoContenidoSelected !== null}}
                            >
                                {
                                    this.props.tiposContenido && this.props.tiposContenido.map(tc => (
                                    <MenuItem key={tc.idTipoContenido} value={tc.idTipoContenido}>
                                        {tc.nombre}
                                    </MenuItem>))
                                }
                            </TextField>
                        </Paper>
                    </Col>
                    
                    <Col md={6}>
                        <Paper className='myBox no-margin'>
                            <TextField className='myInput'        
                                label={`${this.props.tipoContenidoSelected && this.props.tipoContenidoSelected.nombre !== "Preguntas frecuentes" ? 'Nombre' : 'Pregunta'}`}
                                name='nombre'
                                fullWidth
                                required
                                error={this.props.error && this.props.error.nombre}
                                helperText={this.props.error && this.props.error.nombre ? this.props.error.nombre : ""}
                                value={this.props.nombre}
                                onChange={this.props.handleOnChange}
                            />
                        </Paper>
                    </Col>
                </Row>

                <Row>
                    <Col md={6}>
                        {
                            this.props.tipoContenidoSelected && this.props.tipoContenidoSelected.nombre !== "Preguntas frecuentes" 
                            ? <Paper className='myBox no-margin'>
                                <TextField className='myInput'
                                    name="startDate"
                                    label="Fecha de inicio"
                                    InputLabelProps={{ shrink: true, required: true }}
                                    type="date"
                                    value={this.props.fechaActivacion}
                                    onChange={(e)=> this.props.handleOnClickDia({fechaActivacion: e.target.value})}
                                />
                            </Paper>
                            : "" 
                        }
                    </Col>
                    <Col md={6}>
                        {
                            this.props.tipoContenidoSelected && this.props.tipoContenidoSelected.nombre !== "Preguntas frecuentes"
                            ? <Paper className='myBox no-margin'>
                                <TextField className='myInput'
                                    name="endDate"
                                    label="Fecha de finalización"
                                    error={this.props.error && this.props.error.fecha}
                                    helperText={this.props.error && this.props.error.fecha ? this.props.error.fecha : ""}
                                    InputLabelProps={{ shrink: true, required: true }}
                                    type="date"
                                    value={this.props.fechaDesactivacion}
                                    onChange={(e)=> this.props.handleOnClickDia({fechaDesactivacion: e.target.value})}
                                />
                            </Paper>
                            : "" 
                        }
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        {this.props.tipoContenidoSelected && this.props.tipoContenidoSelected.nombre !== "Preguntas frecuentes" 
                        ? 
                            <>
                                <DragAndDrop 
                                    accept='image/jpeg, image/png, image/gif'
                                    message='Arrastra la imagen o'
                                    messageBottom={this.props.tipoContenidoSelected ? this.props.tipoContenidoSelected.observacion : undefined}
                                    handleOnDrop={this.props.handleOnDropFile}
                                    multiple={false}
                                />
                                <p style={{color: 'red', fontSize: 16, textAlign: 'center'}}>{this.props.error && this.props.error.imagen}</p>
                            </>
                        :
                            <Paper className='myBox no-margin'>
                                <TextField 
                                    label='Respuesta'
                                    name='textoLargo'
                                    multiline={true}
                                    fullWidth
                                    required
                                    error={this.props.error && this.props.error.textoLargo}
                                    helperText={this.props.error && this.props.error.textoLargo ? this.props.error.textoLargo : ""}
                                    value={this.props.textoLargo}
                                    onChange={this.props.handleOnChange}
                                />
                            </Paper>  
                        }
                    </Col>
                </Row>

                {
                    this.props.tipoContenidoSelected && this.props.tipoContenidoSelected.nombre !== "Preguntas frecuentes" && this.props.pathImg !== undefined && 
                    <Row>
                        <Col md={12}>
                            <div className='containerArchivoSubido'>
                                <img 
                                    alt="Banner de previsualización" 
                                    style={{
                                        maxWidth: '80%', 
                                        maxHeight: '500px',
                                        width: this.props.tipoContenidoSelected.idTipoContenido === 1 ? '1417px' : '481px',
                                        height: this.props.tipoContenidoSelected.idTipoContenido === 1 ? '222px' : '627px',
                                        objectFit: 'cover'
                                    }} 
                                    src={this.props.pathImg} 
                                />
                            </div>
                        </Col>
                    </Row>
                }

            </div>
        )
    }
}

ContenidoNuevo.propTypes = {
    tipoContenidoSelected: PropTypes.object.isRequired,
    idTipoContenidoSelected: PropTypes.number.isRequired,
    tiposContenido: PropTypes.array.isRequired,
    handleOnSave: PropTypes.func.isRequired,
    handleOnCancel: PropTypes.func.isRequired,
    handleOnChange: PropTypes.func.isRequired,
    handleOnDropFile: PropTypes.func.isRequired,
}

ContenidoNuevo.defaultProps = {
    tiposContenido: [],
    handleOnCancel: f => f,
    handleOnSave: f => f,
    handleOnChange: f => f,
    handleOnDropFile: f => f,
}

export default ContenidoNuevo